<template>
  <a-layout-header>
    <div class="header-container">
      <div class="logo">
        <a href="/"><img :src="logo" />{{ brand }}</a>
      </div>
      <nav>
        <router-link to="/course">我的课程</router-link>
        <router-link v-if="$feature.CaseLib" to="/case">
          精品案例库
        </router-link>
        <a :href="gpuURL" target="_blank" rel="noopener noreferrer">我要上机</a>
        <a :href="supportUrl" target="_blank" rel="noopener noreferrer">
          帮助中心
        </a>
      </nav>

      <a-popover
        placement="bottomRight"
        overlayClassName="header-dropdown-overlay"
      >
        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
          您好, {{ username }} <a-icon type="down" />
        </a>
        <div class="header-dropdown" slot="content">
          <div class="user mp-flex-justify">
            <div class="name">{{ username }}</div>
            <div class="logout" @click="onLogout">退出</div>
          </div>
          <div class="money  mp-flex-justify">
            <div class="balance">
              余额:
              <span class="highlight">
                {{ formatPrice(account.balance, false) }}
              </span>
            </div>
            <div class="time">
              时长卡:
              <span class="highlight">{{ time }}</span>
            </div>
          </div>
          <div class="money  mp-flex-justify">
            <div class="time">
              算力豆:
              <span class="highlight">{{ beanCount }}</span>
            </div>
            <AButton
              type="link"
              class="btn-apply-bonus"
              @click="applyBonusVisible = true"
            >
              申请算力豆
            </AButton>
          </div>
        </div>
      </a-popover>
    </div>

    <ApplyBonus :visible.sync="applyBonusVisible" />
  </a-layout-header>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { formatPrice, formatTimeToHours } from '@/utils/filter'
import ApplyBonus from './apply-bonus.vue'

export default {
  components: { ApplyBonus },
  data() {
    return {
      applyBonusVisible: false
    }
  },
  computed: {
    ...mapGetters({
      username: 'auth/username'
    }),
    gpuURL() {
      return `${process.env.VUE_APP_GPU_BASE_URL}/host-market/gpu`
    },
    supportUrl() {
      return process.env.VUE_APP_GPU_BASE_URL + process.env.VUE_APP_SUPPORT_URL
    },
    account() {
      return this.$store.state.user
    },
    time() {
      const { timeSec } = this.account.totalBonus || {}
      return formatTimeToHours(timeSec)
    },
    beanCount() {
      const { moneyCent } = this.account.totalBonus || {}
      return formatPrice(moneyCent || 0, false, '')
    },
    logo() {
      return require(process.env.VUE_APP_LOGO_SMALL)
    },
    brand() {
      return process.env.VUE_APP_BRAND
    }
  },
  created() {
    this.getAccount()
    this.fetchCourses()
  },
  methods: {
    ...mapActions({
      getAccount: 'user/fetchAccount',
      fetchCourses: 'course/fetchCourses'
    }),
    ...mapMutations({
      logout: 'auth/FE_LOGOUT'
    }),
    formatPrice,
    onLogout() {
      this.logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.header-container {
  .flex;
  width: @safe-width;
  margin: auto;

  .logo {
    margin-right: @spacing-16x;
    .text-lg;
    .flex;

    a {
      color: @text-color-light;
    }

    img {
      height: 36px;
      margin-right: @spacing-2x;
    }
  }

  nav {
    flex: 1;
    .flex;
    height: 100%;

    a {
      &:not(:last-child) {
        margin-right: 54px;
      }

      .text-lg;
      line-height: @header-height;
      color: @text-color-light-l2;
      position: relative;

      &.router-link-active {
        color: @text-color-light;

        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 2px;
          background: @active;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }

  .ant-dropdown-link {
    color: @text-color-light-l2;
  }
}

.btn-apply-bonus {
  height: 22px;
  padding: 0;
}
</style>
<style lang="less">
.header-dropdown-overlay {
  top: 50px !important;
}

.header-dropdown {
  background: @white;
  border-radius: @spacing-basic;
  width: 260px;

  .user {
    margin-bottom: @spacing-6x;

    .name {
      .text-lg;
      font-weight: @font-weight-bold;
    }

    .logout {
      color: @text-color-l3;
      cursor: pointer;
    }
  }

  .money {
    margin-top: @spacing-3x;
    color: @text-color-l2;

    .highlight {
      color: @green;
      font-weight: @font-weight-bold;
    }
  }
}
</style>
